export enum PasswordRequestValidationState {
    Validating, Valid, Invalid
}
